/**
 * External Dependencies
 */
import 'jquery';
jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener('touchstart', handle, {
      passive: !ns.includes('noPreventDefault'),
    });
  },
};
jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    this.addEventListener('touchmove', handle, {
      passive: !ns.includes('noPreventDefault'),
    });
  },
};
jQuery.event.special.wheel = {
  setup: function (_, ns, handle) {
    this.addEventListener('wheel', handle, { passive: true });
  },
};
jQuery.event.special.mousewheel = {
  setup: function (_, ns, handle) {
    this.addEventListener('mousewheel', handle, { passive: true });
  },
};

import lozad from 'lozad';
import { Fancybox } from '@fancyapps/ui';
const observer = lozad();
observer.observe();

import 'slick-carousel/slick/slick.min';
import flatpickr from 'flatpickr';

// Make flatpickr available globally
window.flatpickr = flatpickr;

import './algolia/algoliasearch.umd';
import './algolia/instantsearch.production.min';
// import './algolia/algolia-search'; // Temporarily disabled - missing algoliasearch package
import './custom';

// Import tracking module
import tracking from './modules/tracking';

// Initialize tracking when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  tracking.init();
});

